import { SUBSCRIPTION_STATUS, DIALOG_MODES, BILLING_CYCLES } from '@/shared/constants/pricing/data'
import { getCurrentPlanKey, formatDate, getSubscriptionStatus, isLegacyPlan, getPlanPrice, formatPlanPrice, getPlanByKey, getStatusConfig, getPaddleProductId, isSameTierDifferentBilling } from '@/shared/constants/pricing/service'

export default {
  data() {
    return {
      SUBSCRIPTION_STATUS, // Make constant available to components
      DIALOG_MODES, // Make constant available to components
      BILLING_CYCLES // Make constant available to components
    }
  },
  computed: {
    // Get current plan key
    planHelpers_currentPlanKey() {
      return getCurrentPlanKey(this.user)
    },
    // Get subscription status
    planHelpers_subscriptionStatus() {
      return getSubscriptionStatus(this.user)
    },
    // Check if plan is legacy
    planHelpers_isLegacyPlan() {
      return isLegacyPlan(this.user)
    },
    // Get status config for UI
    planHelpers_statusConfig() {
      return getStatusConfig(this.planHelpers_subscriptionStatus)
    }
  },
  methods: {
    // Format date for display
    planHelpers_formatDate(date) {
      return formatDate(date)
    },
    // Get full plan data object with name and price (publicId now includes billing cycle)
    planHelpers_getPlanData(publicId) {
      if (!publicId) return { name: 'Free', price: 0, formattedPrice: '$0/month' }
      const plan = getPlanByKey(publicId)
      // Detect billing cycle: _annual or _yearly = yearly, otherwise monthly
      const isMonthly = !publicId.includes('_annual') && !publicId.includes('_yearly')
      const price = getPlanPrice(publicId, isMonthly)
      return {
        ...plan,
        name: plan?.name || 'Free',
        price,
        formattedPrice: formatPlanPrice(price, isMonthly)
      }
    },
    // Get plan price by public_id
    planHelpers_getPlanPrice(publicId) {
      if (!publicId) return 0
      // Detect billing cycle: _annual or _yearly = yearly, otherwise monthly
      const isMonthly = !publicId.includes('_annual') && !publicId.includes('_yearly')
      return getPlanPrice(publicId, isMonthly)
    },
    // Get Paddle product ID from public_id
    planHelpers_getPaddleProductId(publicId) {
      return getPaddleProductId(publicId)
    },
    // Check if two plans are same tier but different billing cycle
    planHelpers_isSameTierDifferentBilling(publicId1, publicId2) {
      return isSameTierDifferentBilling(publicId1, publicId2)
    }
  }
}
